import { DestroyRef, inject, Injectable, NgZone } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { RestaurantService } from './restaurant.service';
import { filter, takeUntil } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  private authService = inject(AuthService);
  private restaurantService = inject(RestaurantService);
  private destroy$ = new Subject<void>();

  constructor(
    private ngZone: NgZone = inject(NgZone),
    private router: Router = inject(Router),
    private destroyRef: DestroyRef = inject(DestroyRef),
  ) {
    this.initPostHog();
    this.bootstrapIdentity();
    this.watchRestaurant();
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }

  private initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '2026-01-30',
        disable_session_recording: true,
      });
    });
  }

  private bootstrapIdentity() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      this.identify(user);
    }

    this.authService.updatedUserProfile$
      .pipe(filter(Boolean), takeUntil(this.destroy$))
      .subscribe((user: any) => this.identify(user));
  }

  private watchRestaurant() {
    this.restaurantService.currentRestaurantDetails$
      .pipe(filter(Boolean), takeUntil(this.destroy$))
      .subscribe((restaurant: any) => {
        this.ngZone.runOutsideAngular(() => {
          posthog.register({ restaurant_id: restaurant.restaurant_id });
        });
      });
  }

  identify(user: any) {
    if (!user?.user_id) return;
    this.ngZone.runOutsideAngular(() => {
      posthog.identify(String(user.user_id), {
        restaurant_id: user.restaurant_id,
      });
    });
  }

  reset() {
    this.ngZone.runOutsideAngular(() => {
      posthog.reset();
    });
  }
}
